// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"424b7e2ac81b069c3547","303":"69ea2490dad8af81b7ca","495":"b2819a34ebc0c99e4a5a"}[chunkId] + ".js";
};